export const bonusesApprovalStages = {
  FABROS_COLORING_LEAD_EDITOR_APPROVED_BONUSES: 'fabros_coloring_lead_editor_approved_bonuses',
  FABROS_COLORING_LEAD_TESTER_APPROVED_BONUSES: 'fabros_lead_tester_approved_bonuses',
  XFLOW_COLORING_LEAD_EDITOR_APPROVED_BONUSES: 'xflow_coloring_lead_editor_approved_bonuses',
};
